import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setProductLoading, setProductError, setGalleryFiles } from "../../repository/slice";
import { IProduct } from "../../types/IProduct";

function* deleteProductImageWorker({ payload }: any): SagaIterator {
    try {
        yield put(setProductLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, "/api/shop/product/admin/delete-image/" + payload.filename);
        if (isError) {
            yield put(setProductError(message));
        } else{
            yield put(setGalleryFiles(data));
        }
    } catch (error) {
        console.error("deleteProductImageWorker: ", error);
    } finally {
        yield put(setProductLoading(false));
    };
};

export function* deleteProductImageWatcher() {
    yield takeLatest("@saga/DELETE_PRODUCT_IMAGE", deleteProductImageWorker);
};